const loadRules = { // 加载规则，对象名用于匹配路由，匹配不到直接过，匹配到后执行check方法获取状态，如果为true则对应模块已经存在，否则加载url模块
    center: {
        name: 'center',
        devUrl: ['http://localhost:8080/js/enginePcCenter.js'],
        distUrl: ['engine/js/enginePcCenter.js'],
        check: () => {
            return !!window.enginePcCenter;
        },
    },
    branchList: {
        name: 'branchList',
        devUrl: ['http://localhost:8080/js/enginePcBranch.js'],
        distUrl: ['engine/js/enginePcBranch.js'],
        check: () => {
            return !!window.enginePcBranch;
        },
    }
};

const loading = () => {
    try { // 可能路由拦截到的时候dom还没有渲染，所以这里捕获错误让它继续往下走
        let bodyClass = document.querySelector('body').getAttribute('class') || '';
        bodyClass = bodyClass.concat(' hidden-empty-style');
        document.querySelector('body').setAttribute('class', bodyClass);
        let tloadClass = document.querySelector('.topLoading').getAttribute('class');
        tloadClass = tloadClass.replace('vue-hidden', '');
        tloadClass = tloadClass.replace('hidden', '');
        document.querySelector('.topLoading').setAttribute('class', tloadClass);
    } catch (e) {
        // console.log('err', e);
    }
};
const clearLoaing = () => {
    let bodyClass = document.querySelector('body').getAttribute('class');
    if (bodyClass) {
        bodyClass = bodyClass.replace('hidden-empty-style', '');
        document.querySelector('body').setAttribute('class', bodyClass);
    }

    let tloadClass = document.querySelector('.topLoading').getAttribute('class');
    if (tloadClass.indexOf('vue-hidden') < 0) {
        tloadClass = tloadClass.concat(' vue-hidden');
        document.querySelector('.topLoading').setAttribute('class', tloadClass);
    }
};

const loadScript = (url, callback) => {
    const script = document.createElement('script');
    const fn = callback || function () {};
    script.type = 'text/javascript';
    if (script.readyState) { // IE
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                fn();
            }
        };
    } else { // 其他浏览器
        script.onload = function () {
            fn();
        };
    }
    // 如果可以获取到版本号，version为版本号，否则加个时间戳
    script.src = window.app.projectConfig ? `${url}?version=${window.app.projectConfig.libsVersion}` : `${url}?version=${new Date().getTime()}`;
    document.getElementsByTagName('head')[0].appendChild(script);
};

const load = (item, callback) => {
    loading();
    let urls;
    const fn = callback || function () {};
    let finished = 0;
    if (process.env.NODE_ENV === 'production') {
        urls = item.distUrl;
    } else {
        urls = item.devUrl;
    }
    if (!Array.isArray(urls)) urls = urls.split(',');
    urls.forEach((url) => {
        loadScript(url, () => {
            finished++;
            if (finished === urls.length) {
                clearLoaing();
                fn();
            }
        });
    });
};

export default {
    load,
    loadRules
};
